var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckFalse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.8816,
    height: 25,
    rx: 5,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28192 8L18.1169 18",
    stroke: "white",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1161 8L8.28114 18",
    stroke: "white",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFalse);
export default __webpack_public_path__ + "static/media/check_false.c2b2090818a8b0c88481d6d6439259d9.svg";
export { ForwardRef as ReactComponent };